;(function (angular, _) {
  'use strict'
  angular
    .module('kilo.common')
    .directive('appSidebar', AppSidebarDirective)

  AppSidebarController.$inject = ['urls', 'TokenSwitcherService']

  function AppSidebarController (urls, TokenSwitcherService) {
    var self = this;
    _.extend(self, {
      urls: urls,
      tokenSwitcherService: TokenSwitcherService,
      app: {
        soli: {
          color: '#673AB7',
          element: {},
          has: false
        },
        loka: {
          color: '#FFB74D',
          element: {},
          has: false
        },
        fluid: {
          color: '#1565C0',
          element: {},
          has: false
        },
        alia: {
          color: '#00695C',
          element: {},
          has: false
        }
      },
      goTo: goTo
    })
    self.$onInit = function () {
      hasApp()
    }
    function hasApp () {
      self.app.soli.element = self.apps.find((element) => btoa(element._id) === self.tokenSwitcherService.accessibleApps.SOLITECH)
      self.app.soli.has = !!self.app.soli.element
      self.app.soli.color = self.app.soli.has ? "#00B4EC" : '#E6E6E6'
      self.app.loka.element = self.apps.find((element) => btoa(element._id) === self.tokenSwitcherService.accessibleApps.LOKATECH)
      self.app.loka.has = !!self.app.loka.element
      self.app.loka.color = self.app.loka.has ? '#FFB74D' : '#E6E6E6'
      self.app.fluid.element = self.apps.find((element) => btoa(element._id) === self.tokenSwitcherService.accessibleApps.FLUIDTECH)
      self.app.fluid.has = !!self.app.fluid.element
      self.app.fluid.color = self.app.fluid.has ? '#1565C0' : '#E6E6E6'
      self.app.alia.element = self.apps.find((element) => btoa(element._id) === self.tokenSwitcherService.accessibleApps.ALIATECH)
      self.app.alia.has = !!self.app.alia.element
      self.app.alia.color = self.app.alia.has ? '#00695C' : '#E6E6E6'
    }

    function switchApp (app) {
      self.tokenSwitcherService.switchApp(app).then((token) => {
        const baseUrl = self.app[app].element.redirectUri
        self.visible = false
        self.closeAll()
        window.open(`${baseUrl}#${token}`,'_blank')
      })
    }

    function goTo (app) {
      switchApp(app)
    }
  }
  function AppSidebarDirective () {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/app-sidebar/app-sidebar.html',
      controllerAs: '$ctrl',
      controller: AppSidebarController,
      bindToController: {
        apps: '=',
        visible: '=',
        closeAll: '='
      }
    }
  }
})(window.angular, window._)
